import { createAction } from 'redux-actions';
import getSubscriptionsDetails from 'ui-forms-editor-automation-lib/api/getSubscriptionsDetails';
import getDynoGuid from 'ui-forms-editor-automation-lib/selectors/dynoSelectors/getDynoGuid';
import getSubscriptionsDetailsRequestState from 'ui-forms-editor-automation-lib/selectors/subscriptions/getSubscriptionsDetailsRequestState';
export const REQUEST_SUBSCRIPTIONS_DETAILS = '@@lib/REQUEST_SUBSCRIPTIONS_DETAILS';
export const RECEIVE_SUBSCRIPTIONS_DETAILS = '@@lib/RECEIVE_SUBSCRIPTIONS_DETAILS';
export const FAIL_GETTING_SUBSCRIPTIONS_DETAILS = '@@lib/FAIL_GETTING_SUBSCRIPTIONS_DETAILS';
const requestSubscriptionsDetails = createAction(REQUEST_SUBSCRIPTIONS_DETAILS);
const receiveSubscriptionsDetails = createAction(RECEIVE_SUBSCRIPTIONS_DETAILS);
const failGettingSubscriptionsDetails = createAction(FAIL_GETTING_SUBSCRIPTIONS_DETAILS);
const fetchSubscriptionsDetails = () => (dispatch, getState) => {
  const state = getState();
  if (!getSubscriptionsDetailsRequestState(state).shouldBeRequested()) {
    return Promise.resolve();
  }
  const dynoGuid = getDynoGuid(state);
  dispatch(requestSubscriptionsDetails());
  getSubscriptionsDetails(dynoGuid).then(subscriptions => {
    dispatch(receiveSubscriptionsDetails(subscriptions));
  }).catch(() => {
    dispatch(failGettingSubscriptionsDetails());
  });
  return undefined;
};
export default fetchSubscriptionsDetails;